import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterModule, Routes } from '@angular/router';

import { KbLayoutComponent } from './components/kb-layout/kb-layout.component';
import { KbArticleListComponent } from './components/kb-article-list/kb-article-list.component';
import { KbArticleViewComponent } from './components/kb-article-view/kb-article-view.component';
import { KbArticleEditComponent } from './components/kb-article-edit/kb-article-edit.component';
import { KbRevisionHistoryComponent } from './components/kb-revision-history/kb-revision-history.component';
import { KbWelcomeComponent } from './components/kb-welcome/kb-welcome.component';
import { KbArticleNewComponent } from './components/kb-article-new/kb-article-new.component';
import { MarkdownPipe } from './pipes/markdown.pipe';

const routes: Routes = [
  {
    path: 'knowledge-base',
    component: KbLayoutComponent,
    children: [
      { path: '', component: KbWelcomeComponent },
      { path: 'new', component: KbArticleNewComponent },
      { path: ':categorySlug', component: KbArticleListComponent },
      { path: ':categorySlug/:articleSlug', component: KbArticleViewComponent },
      { path: ':categorySlug/:articleSlug/edit', component: KbArticleEditComponent },
      { path: ':categorySlug/:articleSlug/history', component: KbRevisionHistoryComponent },
    ]
  }
];

@NgModule({
  declarations: [
    KbLayoutComponent,
    KbArticleListComponent,
    KbArticleViewComponent,
    KbArticleEditComponent,
    KbRevisionHistoryComponent,
    KbWelcomeComponent,
    KbArticleNewComponent,
    MarkdownPipe
  ],
  imports: [
    CommonModule,
    FormsModule,
    RouterModule.forRoot(routes)
  ]
})
export class KnowledgeBaseModule {}
